import { Utils } from '@genial/utils';

type SelectDates = {
  initialDate: Date | undefined;
  finalDate: Date | undefined;
};

export const getNoticeText = (dates: SelectDates): string => {
  return `Informações dos dias ${Utils.Mask.DateFormat(
    dates.initialDate,
    'dd/MM/yyyy'
  )} - ${Utils.Mask.DateFormat(dates.finalDate, 'dd/MM/yyyy')}.`;
};
